import { render, staticRenderFns } from "./CustomCostCarrier.vue?vue&type=template&id=38c02b1d"
import script from "./CustomCostCarrier.vue?vue&type=script&lang=js"
export * from "./CustomCostCarrier.vue?vue&type=script&lang=js"
import style0 from "./CustomCostCarrier.vue?vue&type=style&index=0&id=38c02b1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports